import React, { useEffect } from 'react';
import './Services.css';
import ServiceCard from '../../Components/ServiceCard/ServiceCard';
import FAQs from '../../GlobalComponents/FAQs';
import ReadyToAsk from '../../GlobalComponents/ReadyToAsk/ReadyToAsk';
import SEO from '../../Components/SEO';
import { useTranslation } from 'react-i18next';

// Image assets
import doc from '../../Assets/services/doc.jpg';
import short from '../../Assets/services/short.jpg';
import tv_shows from '../../Assets/services/tv_shows.png';
import promotional_videos from '../../Assets/services/promotional.jpg';
import interview from '../../Assets/services/interview.jpg';
import video_pro from '../../Assets/services/video_pro.jpg';
import graphic from '../../Assets/services/graphics.jpg';
import event from '../../Assets/services/event.jpg';
import social from '../../Assets/services/social.jpg';
import post_pro from '../../Assets/services/post_pro.jpg';
import crew from '../../Assets/services/crew.png';
import equip from '../../Assets/services/equipment.jpg';
import market from '../../Assets/services/market.jpg';

const imageMap = [
  doc,
  short,
  tv_shows,
  promotional_videos,
  interview,
  video_pro,
  graphic,
  event,
  social,
  social,
  post_pro,
  crew,
  equip,
  market
];

const Services = () => {
  const { t } = useTranslation();
  const translatedServices = t('servicesData.items', { returnObjects: true });

  // Add extra layout info (styling, image, etc.)
  const servicesData = translatedServices.map((item, index) => ({
    ...item,
    img: imageMap[index],
    bgColor: index % 2 === 0 ? 'var(--section-bg)' : 'var(--section-bg-two)',
    slide: index % 2 === 0 ? 'slide-right' : 'slide-left',
    padding: index % 2 === 0 ? '0 0 0 0px' : '0 120px 0 0',
    contentJustify: index % 2 === 0 ? 'start' : 'end',
    flexDir: index % 2 !== 0 ? 'row-reverse' : '',
    projectCount: '60+'
  }));

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEO
        title="Services - Filmarz"
        description="Filmarz"
        keywords="art, productions"
        author="Three Mean"
      />
      <div className='services-main-section'>
        {servicesData.map((item, index) => (
          <ServiceCard
            key={index}
            serviceHeading={item.serviceName}
            serviceHeadingTwo={item.serviceNameTwo}
            serviceBanner={item.img}
            paraOne={item.paraOne}
            paraTwo={item.paraTwo}
            paraThree={item.paraThree}
            backgroundColor={item.bgColor}
            flexDirection={item.flexDir}
            justifyContent={item.contentJustify}
            padding={item.padding}
            slideSection={item.slide}
            projectDone={item.projectCount}
            ind={index}
          />
        ))}
        <FAQs />
        <ReadyToAsk />
      </div>
    </>
  );
};

export default Services;
